import "./index.css";
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
var Loader = forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'bold' : _ref$weight,
    className = _ref.className;
  return jsx("div", {
    ref: ref,
    className: classNames('cds-loader', "cds-loader--size-".concat(size), "cds-loader--weight-".concat(weight), className)
  });
});
export { Loader };